<div [appEditableWithRole]="readOnly ? null : ['MERCHANT_ADMIN']">
  <button
    *ngIf="!readOnly"
    class="my-4"
    mat-raised-button
    color="primary"
    [routerLink]="'create'"
    [routerLinkActive]="'active'"
  >
    <mat-icon>add</mat-icon>
    {{ "MERCHANT.BTN.ADD" | translate }}
  </button>

  <ng-container *ngIf="(isLoading$ | async) === false">
    <div *ngIf="this.siteId; else siteList">
      <app-merchant-site-card
        *ngIf="activeSite$ | async as activeSite"
        [site]="activeSite"
        [readOnly]="readOnly"
      ></app-merchant-site-card>
    </div>
    <ng-template #siteList>
      <div class="sites-container">
        <app-merchant-site-card
          *ngFor="
            let site of readOnly
              ? (sitesByMerchantId$ | async)
              : (data$ | async)
          "
          [site]="site"
          [readOnly]="readOnly"
        ></app-merchant-site-card>
      </div>
    </ng-template>
  </ng-container>
</div>
